__webpack_require__.j = "saleHeaderFooter";